import Modal from "./Modal";
import BasicButton from "./BasicButton";

interface ConfirmDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => Promise<void>;
  deleteLoading: boolean;
  title?: string;
}

function ConfirmDeleteModal({
  isOpen,
  onClose,
  onDelete,
  deleteLoading,
  title = "데이터 삭제",
}: ConfirmDeleteModalProps) {
  return (
    <Modal title={title} open={isOpen} onClose={onClose}>
      <div className="flex h-full w-full flex-col py-10">
        <div className="flex h-full flex-col items-center justify-center text-xl">
          <p>삭제된 정보는 복구할 수 없습니다.</p>
          <p>정말 삭제하시겠습니까?</p>
        </div>
        <BasicButton text="아니오" onClick={onClose} variant="outlined" />
        <BasicButton
          text="삭제"
          onClick={onDelete}
          variant="error"
          loading={deleteLoading}
        />
      </div>
    </Modal>
  );
}

export default ConfirmDeleteModal;
